import type { EmailBlock, EmailBlockKind } from './types';
import { HOTELSPOT_LOGO_URL } from './types';

let counter = 0;

/** Identyfikator bloku. Wystarczy unikalny w obrębie jednego dokumentu. */
const nextId = (kind: EmailBlockKind): string => {
  counter += 1;
  return `${kind}-${Date.now().toString(36)}-${counter}`;
};

/**
 * Nowy blok z treścią zastępczą. Puste pola zostawiałyby w podglądzie dziury i nie byłoby
 * widać, co się właśnie dodało.
 */
export const createBlock = (kind: EmailBlockKind): EmailBlock => {
  const id = nextId(kind);
  switch (kind) {
    case 'logo':
      return { id, kind: 'logo', src: HOTELSPOT_LOGO_URL, alt: 'hotelspot', height: 26, align: 'left' };
    case 'heading':
      return { id, kind: 'heading', text: 'Nagłówek sekcji', level: 2, align: 'left' };
    case 'text':
      return {
        id,
        kind: 'text',
        text: 'Treść wiadomości. Podwójny enter zaczyna nowy akapit.',
        align: 'left',
        small: false,
      };
    case 'button':
      return { id, kind: 'button', label: 'Przejdź do panelu', href: '{{panelUrl}}', align: 'left', fullWidth: false };
    case 'image':
      return { id, kind: 'image', src: '', alt: '', href: '', radius: 0 };
    case 'list':
      return { id, kind: 'list', items: ['Pierwsza korzyść', 'Druga korzyść', 'Trzecia korzyść'] };
    case 'divider':
      return { id, kind: 'divider' };
    case 'spacer':
      return { id, kind: 'spacer', height: 24 };
    case 'footer':
    default:
      return {
        id,
        kind: 'footer',
        text: 'HotelSpot, ul. Przykładowa 1, Gdańsk',
        unsubscribeUrl: '{{unsubscribeUrl}}',
        unsubscribeLabel: 'Wypisz się z powiadomień',
      };
  }
};

export const BLOCK_LABELS: Record<EmailBlockKind, string> = {
  logo: 'Logo',
  heading: 'Nagłówek',
  text: 'Tekst',
  button: 'Przycisk',
  image: 'Obraz',
  list: 'Lista',
  divider: 'Linia',
  spacer: 'Odstęp',
  footer: 'Stopka',
};
